<template>
  <h1 id="seo-h1" tabindex="-1">
    {{ $t(`hidden-h1.${countryCode.toLowerCase()}`) }}
  </h1>
</template>

<script setup lang="ts">
const { countryCode } = useI18nLocale()
</script>

<style lang="scss" scoped>
#seo-h1 {
  width: 1px;
  height: 1px;
  position: absolute;
  border: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  -webkit-clip-path: inset(50%);
  clip-path: inset(50%);
}
</style>
